import React, { Component } from 'react'
import '../../../styles/checkout/mainStyle.css'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'

const isIE = /*@cc_on!@*/false || !!document.documentMode;

export class Mco extends Component {
    state = {
        topRef: React.createRef()
    }

    componentDidMount() {
        this.props.selectMode('integration_guide');
    }

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    render() {
        return (
            <div  className= "stepPageContainer"> 
                <h3 ref={this.state.topRef} className="stepPageTitle">Testing Your Moneris Checkout Integration</h3>  
                <div ref={this.state.topRef} >
                    <p>In the testing stage of development:</p>
                    <ol style={{paddingInlineStart: "20px", paddingLeft: isIE ? '2vw' : ''}}>                                               
                        <li>Use the testing Merchant Resource Center at  <a href="https://esqa.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://esqa.moneris.com/mpg</a> to configure your Moneris Checkout page for testing purposes.<br /><br /></li>
                        <li>Use the testing URL for server to server requests:<br />
                        <a href="https://gatewayt.moneris.com/chktv2/request/request.php" target="_blank" rel="noopener noreferrer">https://gatewayt.moneris.com/chktv2/request/request.php</a>
                        <br /><br />
                        </li>
                        <li>Use the testing JavaScript library:<br />
                            <pre><span id="code6">&lt;script src="https://gatewayt.moneris.com/chktv2/js/chkt_v2.00.js"&gt;&lt;/script&gt;</span></pre>
                        </li>
                        <li>Set up your myCheckout object to the testing mode:<br />
                            <pre><span id="code7">myCheckout.setMode("qa");</span></pre>
                        </li>
                        <li>In all Preload requests use the value "qa" for the environment variable.<br /><br /></li>
                        <li>In all Preload requests, make sure that you are using the testing version of your credentials for <b>Store ID</b>, <b>API token</b> and <b>Checkout ID</b>.<br /><br /></li>
                        <li>In all Receipt requests use the value "qa" for the environment variable.<br /><br /></li>
                        <li>In all Receipt requests, make sure that you are using the testing version of your credentials for <b>Store ID</b>, <b>API token</b> and <b>Checkout ID</b>.</li>
                    </ol>
                </div>
                <h4 style={{ marginTop: '7vh', color: '#00a1cb', fontSize: '1.2rem'}}>Test Cards for Moneris Checkout</h4>
                <p>Test card numbers are available for testing your Moneris Checkout integration. For the most current test <br/>card information, see the Moneris developer portal at:</p>
                <a href="https://developer.moneris.com/en/More/Testing/Testing%20a%20Solution" target="_blank"  rel="noopener noreferrer">https://developer.moneris.com/en/More/Testing/Testing%20a%20Solution</a>
                <p style={{fontWeight: 'bold'}}>Special information for testing convenience fee/service fee:</p>
                <p>For testing transactions with convenience fee/service fee in Moneris Checkout, you must use the specific test credentials:</p>
                <p>Store ID: monca00392</p>
                <p>Username: DemoUser</p>
                <p>Password: password</p>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode };
  }

export default connect(mapStateToProps,{selectMode})(Mco)
